import { cloneDeep } from 'lodash';
import { LOAD_INITIAL_STATE, RESET_STATE } from '../types';
import { ActionTypes, SecretManagerReducerState, SET_ACTIVE_SECRET_MANAGERS } from './types';

const initialState: SecretManagerReducerState = {
    activeSecretManagers: [],
};

export const SecretManagerReducer = (state = initialState, action: ActionTypes): SecretManagerReducerState => {
    switch (action.type) {
        case SET_ACTIVE_SECRET_MANAGERS:
            return { ...state, activeSecretManagers: action.payload };
        case LOAD_INITIAL_STATE:
            return { ...state, ...(action.payload.SecretManagerReducer || {}) };
        case RESET_STATE:
            return cloneDeep(initialState);
        default:
            return state;
    }
};
